import { sportShort } from "@/lib/sport";

export default function SportBadge({ sportLabel, testid, className = "" }) {
  if (!sportLabel || !sportLabel.startsWith("College")) return null;
  return (
    <span
      data-testid={testid}
      className={`inline-flex shrink-0 items-center rounded-sm border border-volt/40 bg-volt/10 px-1.5 py-0.5 font-score text-[9px] font-bold tracking-widest text-volt ${className}`}
    >
      {sportShort(sportLabel)}
    </span>
  );
}
